var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3012977901582967232(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e79bd;}.cls-2{fill:#2d3e50;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.25542,68.96584h0a2.97123,2.97123,0,0,0-3.98107.67524L32.20691,80.12873c-5.61875,6.57805-9.5416,5.52455-11.89863,3.34363A8.70442,8.70442,0,0,1,17.589,77.06722V59.42L4.41256,78.84972A5.0384,5.0384,0,0,0,3.65,82.70527L9.30552,109.8518v2.1927H37.56681l1.11854-12.44076a61.59733,61.59733,0,0,1,4.32843-17.844c1.14257-2.78833,2.276-5.386,3.03-7.4326A4.54038,4.54038,0,0,0,44.25542,68.96584Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.13449,19.277a10.89928,10.89928,0,0,0-7.98767-3.32146H33.14264a11.34032,11.34032,0,0,0-11.306,11.306V78.49021a4.41679,4.41679,0,0,0,1.22024,2.01093c.67549.62567,1.08639.6039,1.26071.59455.42958-.028,2.02337-.35487,4.74715-3.52067L37.068,67.17489a6.80358,6.80358,0,0,1,.64125-.72219V27.2615a4.512,4.512,0,0,1,4.48254-4.47944h70.955a4.512,4.512,0,0,1,4.48256,4.47944V81.0241a4.50656,4.50656,0,0,1-4.48256,4.47944H45.90855a55.8831,55.8831,0,0,0-1.99223,6.82655h69.2305a11.3403,11.3403,0,0,0,11.30911-11.306V27.2615A10.89739,10.89739,0,0,0,121.13449,19.277ZM32.6757,57.32572a4.43925,4.43925,0,1,1,1.34475-3.18138A4.35474,4.35474,0,0,1,32.6757,57.32572Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.70123,41.44335h18.11613a1.73257,1.73257,0,0,0,0-3.46513H82.70123a1.73257,1.73257,0,1,0,0,3.46513Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.45386,41.44335H74.293a1.73257,1.73257,0,0,0-.00025-3.46513H55.45386a1.73257,1.73257,0,0,0,0,3.46513Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.70123,70.7129h18.11613a1.73248,1.73248,0,0,0,0-3.465H82.70123a1.73248,1.73248,0,1,0,0,3.465Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.45386,70.7129H74.293a1.73248,1.73248,0,0,0-.00025-3.465H55.45386a1.73248,1.73248,0,1,0,0,3.465Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.70123,56.07821h18.11613a1.73261,1.73261,0,0,0,0-3.46521H82.70123a1.7326,1.7326,0,0,0,0,3.46521Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.45386,56.07821H74.293a1.7326,1.7326,0,0,0-.00025-3.46521H55.45386a1.7326,1.7326,0,0,0,0,3.46521Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3012977901582967232);
export default __webpack_public_path__ + "static/media/3012977901582967232.9ebedb00.svg";
export { ForwardRef as ReactComponent };